const tiEmpresasResp = [
  'MICROSEANS S.A. (TABLET)',
  'DADYILHA (IMPRESSORA)',
  '3CORP (VOIP)',
  'FUNDAMENTAL (COMPUTADORES)',
  'CLARO S.A. (TELEFONE)',
  'ALGAR (INTERNET)',
  'LESTE RIO (INTERNET)',
  'PRONTOGOV (INTERNET)',
  'SUPERVISÃO DE INFORMÁTICA'
];

export default tiEmpresasResp;
